import React from "react";
import { bool, shape, string } from "prop-types";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { Row } from "react-bootstrap";

import { actions as debinActions, selectors as debinSelectors } from "reducers/debin";
import { selectors as sessionSelectors } from "reducers/session";

import * as i18n from "util/i18n";

import I18n from "pages/_components/I18n";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";

const ActionConfirmation = ({ isDesktop, scheduledDebin, username, fetching }) => {
    const { action } = useParams();

    const CURRENCY = scheduledDebin?.debin?.amount?.currency === "ARS" ? "$" : scheduledDebin?.debin?.amount?.currency;
    const AMOUNT = scheduledDebin?.debin?.amount?.quantity;
    const INSTALLMENTS = scheduledDebin?.debin?.installmentLimit;
    const CLIENT_NAME = username;

    // Definir action y params basados en el tipo de acción
    let execAction;
    let idActivity = `scheduled.debin.${action}.send`;

    switch (action) {
        case "accept":
            execAction = debinActions.acceptScheduledDebinSend;
            break;
        case "reject":
            execAction = debinActions.rejectScheduledDebinSend;
            break;
        case "pause":
            execAction = debinActions.pauseScheduledDebinSend;
            break;
        case "cancel":
            execAction = debinActions.cancelScheduledDebinSend;
            break;
        case "activate":
            execAction = debinActions.activateScheduledDebinSend;
            break;
        default:
            execAction = null;
            idActivity = "";
            break;
    }

    const params = {
        idTransaction: scheduledDebin?.idTransaction,
        username,
        scheduledDebin,
    };

    return (
        <>
            {scheduledDebin && action && (
                <>
                    <Notification scopeToShow="debin" />

                    <ResponsiveHeader
                        id={`debin.scheduled.${action}.title`}
                        className="header-without-button"
                        backLinkTo="/scheduledDebin"
                    />
                    <MainContainer className="loans">
                        <I18n component="h3" id="debin.scheduled.acceptReject.confirmation.subTitle" />

                                        <Row className="form-background pt-6">
                                            <div style={{ padding: "0px 24px 0px 24px" }}>
                                                <GridTable className="equivalent-total-balance">
                                                    <GridTable.Container columns={4} columnsTemplate="fixed">
                                                        <GridTable.Data columnStart={1} rowStart={1}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.debitAccount",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    scheduledDebin.buyer.shortLabel
                                                                        ? `····${scheduledDebin.buyer.shortLabel}`
                                                                        : "-"
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 2 : 1}
                                                            rowStart={isDesktop ? 1 : 2}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.amount",
                                                                )}
                                                                valueText={
                                                                    <FormattedAmount
                                                                        className="data-label"
                                                                        currency={scheduledDebin.debin.amount.currency}
                                                                        quantity={scheduledDebin.debin.amount.quantity}
                                                                    />
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 3 : 1}
                                                            rowStart={isDesktop ? 1 : 3}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.concept",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    scheduledDebin.debin.concept
                                                                        ? scheduledDebin.debin.concept
                                                                        : "-"
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 4 : 1}
                                                            rowStart={isDesktop ? 1 : 4}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.reference",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    scheduledDebin.debin.reference
                                                                        ? scheduledDebin.debin.reference
                                                                        : "-"
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 5}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.numberOfInstallments",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    scheduledDebin.debin.installmentLimit
                                                                        ? scheduledDebin.debin.installmentLimit
                                                                        : "-"
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 2 : 1}
                                                            rowStart={isDesktop ? 2 : 5}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.benefit",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    scheduledDebin.debin.benefit
                                                                        ? scheduledDebin.debin.benefit
                                                                        : "-"
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 3 : 1}
                                                            rowStart={isDesktop ? 2 : 6}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.startDate",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    <FormattedDate
                                                                        showTime={false}
                                                                        date={scheduledDebin.creationDate}
                                                                    />
                                                                }
                                                            />
                                                        </GridTable.Data>

                                                        <GridTable.Data
                                                            columnStart={isDesktop ? 4 : 1}
                                                            rowStart={isDesktop ? 2 : 7}>
                                                            <CustomData
                                                                titleText={i18n.get(
                                                                    "debin.scheduled.acceptReject.planTotal",
                                                                )}
                                                                titleTextType="TEXT"
                                                                valueTextType="TEXT"
                                                                valueText={
                                                                    <FormattedAmount
                                                                        className="data-label"
                                                                        currency={scheduledDebin.debin.amount.currency}
                                                                        quantity={
                                                                            Number(
                                                                                scheduledDebin.debin.amount.quantity,
                                                                            ) *
                                                                            Number(
                                                                                scheduledDebin.debin.installmentLimit,
                                                                            )
                                                                        }
                                                                    />
                                                                }
                                                            />
                                                        </GridTable.Data>
                                                    </GridTable.Container>
                                                </GridTable>
                                            </div>
                                        </Row>

                                        {action === "accept" && (
                                            <div className="container--alert" role="alert">
                                                <div className="alert alert-info">
                                                    <CustomData
                                                        icon="information_fill.svg"
                                                        titleText={i18n.get("debin.scheduled.acceptReject.info", null, {
                                                            CURRENCY,
                                                            AMOUNT,
                                                            INSTALLMENTS,
                                                            CLIENT_NAME,
                                                        })}
                                                        keepSpaceIfNoValue={false}
                                                    />
                                                </div>
                                                <div style={{ paddingBottom: "10px" }} />
                                            </div>
                                        )}

                                        <Row className="form-actions">
                                            <GeneralCredentialForm
                                                hideIndications
                                                transactionData={params}
                                                action={execAction}
                                                type="otp"
                                                idActivity={idActivity}
                                            />
                                        </Row>
                    </MainContainer>
                </>
            )}
        </>
    );
};
ActionConfirmation.defaultProps = {};

ActionConfirmation.propTypes = {
    isDesktop: bool.isRequired,
    scheduledDebin: shape({}).isRequired,
    username: string.isRequired,
    fetching: bool.isRequired,
};

const mapStateToProps = (state) => ({
    scheduledDebin: debinSelectors.getScheduledDebin(state),
    username: sessionSelectors.getUserFullName(state),
    fetching: debinSelectors.getFetching(state),
});

export default connect(mapStateToProps)(ActionConfirmation);
